var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fcbe00;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.17,
    y: 21.97,
    width: 5.53,
    height: 0.58,
    transform: "translate(47.88 44.51) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.19,
    y: 27.61,
    width: 5.5,
    height: 0.59,
    transform: "translate(47.88 55.81) rotate(-180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.19,
    y: 26.13,
    width: 5.5,
    height: 0.58,
    transform: "translate(47.88 52.83) rotate(-180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.2,
    y: 23.38,
    width: 5.5,
    height: 0.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.8,
    y: 24.77,
    width: 5.53,
    height: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.55,29.15h4.81a.35.35,0,0,1,.35.35v5.2a0,0,0,0,1,0,0H21.17a0,0,0,0,1,0,0V29.53A.38.38,0,0,1,21.55,29.15Z",
    transform: "translate(47.88 63.85) rotate(-180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.99,
    y: 4.39,
    width: 5.53,
    height: 30.32,
    rx: 0.45
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.47,
    y: 10.87,
    width: 5.53,
    height: 23.83,
    rx: 0.45
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.29,
    y: 17.04,
    width: 5.53,
    height: 17.67,
    rx: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.91,36H3.09V32.86a.1.1,0,0,1,.1-.1.1.1,0,0,1,.09.1V35.8H36.72V32.86a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.3635e416.svg";
export { ForwardRef as ReactComponent };